module.exports = __webpack_public_path__ + "static/06-91acc6712f473d4c550a888819103f25.jpg";